<template>
  <div v-if="isVisible"
    class="fixed z-50 p-4 bg-white border border-solid rounded-lg shadow-lg event-type-colors border-neutral-300"
    :style="{ top: `${y}px`, left: `${x}px` }">
    <ul class="space-y-2">
      <li v-for="(color, type) in eventTypeColors" :key="type" class="flex items-center">
        <span class="w-4 h-4 mr-3 rounded-full" :class="[color.bg, color.border]"></span>
        <span class="text-sm">{{ type }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, onMounted, onUnmounted } from "vue";

const props = defineProps({
  initialX: {
    type: Number,
    required: true,
  },
  initialY: {
    type: Number,
    required: true,
  },
  isVisible: {
    type: Boolean,
    required: true,
  },
});

const x = ref(props.initialX);
const y = ref(props.initialY);

const eventTypeColors = {
  "Samtidighedsferieuger": {
    bg: "bg-green-200",
    border: "border-green-300",
  },
  "Særlige feriedage": {
    bg: "bg-purple-200",
    border: "border-purple-300",
  },
  "Søgnedage": {
    bg: "bg-amber-200",
    border: "border-amber-300",
  },
  "Friweekender": {
    bg: "bg-pink-200",
    border: "border-pink-300",
  },
  "Forlagt tjeneste": {
    bg: "bg-teal-200",
    border: "border-teal-300",
  },
  "Kursusvirksomhed": {
    bg: "bg-lime-200",
    border: "border-lime-400",
  },
  "Erstatningsfridag": {
    bg: "bg-gray-200",
    border: "border-gray-300",
  },
  "Sygdom": {
    bg: "bg-red-200",
    border: "border-red-300",
  },
};

function updatePosition(event) {
  const popover = document.querySelector(".event-type-colors");
  if (!popover) return;

  const popoverWidth = popover.offsetWidth;
  const popoverHeight = popover.offsetHeight;
  const headerHeight = 80; // Approximate height of the fixed header

  let newX = event.clientX + window.scrollX + 10;
  let newY = event.clientY + window.scrollY - popoverHeight - 10;

  // Ensure the popover doesn't go off-screen
  if (newX + popoverWidth > window.innerWidth) {
    newX = window.innerWidth - popoverWidth - 10;
  }
  if (newY < headerHeight) {
    newY = event.clientY + window.scrollY + 10;
  }

  x.value = newX;
  y.value = newY;
}

function handleResize() {
  const event = {
    clientX: x.value - window.scrollX,
    clientY: y.value - window.scrollY,
  };
  updatePosition(event);
}

onMounted(() => {
  if (props.isVisible) {
    window.addEventListener("mousemove", updatePosition);
    window.addEventListener("resize", handleResize);
  }
});

onUnmounted(() => {
  window.removeEventListener("mousemove", updatePosition);
  window.removeEventListener("resize", handleResize);
});

watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      x.value = props.initialX;
      y.value = props.initialY;
    }
  }
);

watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      window.addEventListener("mousemove", updatePosition);
      window.addEventListener("resize", handleResize);
    } else {
      window.removeEventListener("mousemove", updatePosition);
      window.removeEventListener("resize", handleResize);
    }
  }
);
</script>